const UPLOADED_IMAGE_PATH = '/uploaded-images/'

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function parseUploadedImageId(url: string | null | undefined): string | null {
  if (!url?.trim()) return null
  const trimmed = url.trim()

  const markerIdx = trimmed.indexOf(UPLOADED_IMAGE_PATH)
  if (markerIdx !== -1) {
    const id = trimmed.slice(markerIdx + UPLOADED_IMAGE_PATH.length).split(/[?#]/)[0]
    if (UUID_RE.test(id)) return id
  }

  if (UUID_RE.test(trimmed)) return trimmed

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const lastSegment = new URL(trimmed).pathname.replace(/\/$/, '').split('/').pop() || ''
      if (UUID_RE.test(lastSegment)) return lastSegment
    } catch {
      return null
    }
  }

  return null
}

export function isUploadedImageUrl(url: string | null | undefined): boolean {
  return !!parseUploadedImageId(url)
}

/** Same-origin path for in-house uploads; external integration logos pass through. */
export function resolveProfileImageDisplayUrl(
  url: string | null | undefined
): string | null {
  if (!url?.trim()) return null
  const uploadId = parseUploadedImageId(url.trim())
  return uploadId ? `${UPLOADED_IMAGE_PATH}${uploadId}` : url.trim()
}

/** User uploads always win over integration/store logos. */
export function pickEffectiveProfileImageUrl(
  ...urls: Array<string | null | undefined>
): string | null {
  for (const url of urls) {
    const trimmed = url?.trim()
    if (trimmed && isUploadedImageUrl(trimmed)) return trimmed
  }
  for (const url of urls) {
    const trimmed = url?.trim()
    if (trimmed) return trimmed
  }
  return null
}

export function pickDisplayProfileImageUrl(
  ...urls: Array<string | null | undefined>
): string | null {
  return resolveProfileImageDisplayUrl(pickEffectiveProfileImageUrl(...urls))
}
